import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';

import {
  cartItemUpdate,
  togglePurchasedPrintPackageCartItem,
} from '../../../../../../../services/checkout/redux/checkoutActions';
import { getCheckoutCart } from '../../../../../../../services/checkout/redux/checkoutSelectors';
import AlbumPrintPackageOptionList from './components/AlbumPrintPackageOptionList';
import { PURCHASED_PRINT_PACKAGE_CONFIGURATION_COMPLETE_MODAL } from './components/PurchasedPrintPackageConfigurationCompleteModal';
import usePurchasesPendingConfiguration from './hooks/usePurchasesPendingConfiguration';
import withModal from '../../../../../../../components/global/modal/withModal';
import useOpenModal from '../../../../../../../hooks/useOpenModal';
import PhotoPricingOptionList from './components/PhotoPricingOptionList';
import CustomPrintOptionList from './components/CustomPrintOptionList';

export const PURCHASES_PENDING_CONFIGURATION_MODAL =
  'modal/PURCHASES_PENDING_CONFIGURATION';

const propTypes = {
  hierarchyItemId: PropTypes.string.isRequired,
  onCheckout: PropTypes.func.isRequired,
  optionProps: PropTypes.object,
  onRequestClose: PropTypes.func.isRequired,
};

const PurchasesPendingConfigurationModal = ({
  hierarchyItemId,
  onCheckout,
  optionProps,
  actionProps,
  onRequestClose,
}) => {
  const openModal = useOpenModal();
  const { albumMembershipPhoto, watermarkSettings } = actionProps ?? {};

  const {
    albumMembershipGroup,
    prepaidPrintPackages,
    prepaidPhotoPricings,
    prepaidCustomPrints,
    albumPrintPackages,
    isAllPhotos,
  } = usePurchasesPendingConfiguration({
    hierarchyItemId,
  });

  const onOptionConfigurationComplete = () => {
    openModal(PURCHASED_PRINT_PACKAGE_CONFIGURATION_COMPLETE_MODAL, {
      watermarkSettings,
    });
    onRequestClose();
  };

  return (
    <Fragment>
      <h4 className="text-center">Add this photo to:</h4>
      <AlbumPrintPackageOptionList
        isAllPhotos={isAllPhotos}
        albumMembershipGroup={albumMembershipGroup}
        prepaidPrintPackages={prepaidPrintPackages}
        albumPrintPackages={albumPrintPackages}
        albumMembershipPhoto={albumMembershipPhoto}
        hasPurchasedPhotoPricings={prepaidPhotoPricings?.length > 0}
        onCheckout={onCheckout}
        optionProps={{
          onConfigurationComplete: onOptionConfigurationComplete,
          watermarkSettings,
          ...(optionProps ?? {}),
        }}
      />
      <PhotoPricingOptionList
        isAllPhotos={isAllPhotos}
        albumMembershipGroup={albumMembershipGroup}
        prepaidPhotoPricings={prepaidPhotoPricings}
        albumMembershipPhoto={albumMembershipPhoto}
        onCheckout={onCheckout}
        optionProps={{
          onConfigurationComplete: onOptionConfigurationComplete,
          watermarkSettings,
          ...(optionProps ?? {}),
        }}
      />
      <CustomPrintOptionList
        isAllPhotos={isAllPhotos}
        albumMembershipGroup={albumMembershipGroup}
        albumMembershipPhoto={albumMembershipPhoto}
        prepaidCustomPrints={prepaidCustomPrints}
        onCheckout={onCheckout}
        optionProps={{
          onConfigurationComplete: onOptionConfigurationComplete,
          watermarkSettings,
          ...(optionProps ?? {}),
        }}
      />
    </Fragment>
  );
};

PurchasesPendingConfigurationModal.propTypes = propTypes;

const mapStateToProps = state => ({
  cart: getCheckoutCart(state),
});

const mapDispatchToProps = {
  onCartItemUpdate: cartItemUpdate,
  onPurchasedPrintPackageToggle: togglePurchasedPrintPackageCartItem,
};

export default withModal(
  compose(connect(mapStateToProps, mapDispatchToProps))(
    PurchasesPendingConfigurationModal,
  ),
  {
    name: PURCHASES_PENDING_CONFIGURATION_MODAL,
    size: 'sm',
    type: 'full',
  },
);
